module.exports = {"420202070":"花湖街道","420202400":"江北管理区","420202402":"黄石港区环磁湖片区工作委员会","420202403":"黄石港区黄石港片区工作委员会","420202404":"黄石港区胜阳港片区工作委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420202.json
// module id = 1711
// module chunks = 0